import React from 'react';
import { MapPin, Calendar } from 'lucide-react';

/**
 * LoteHeader - Header section with lote number, category, location and status
 */
const LoteHeader = ({ lote }) => {
    return (
        <div className="bg-gradient-to-r from-green-600 to-green-500 rounded-lg p-2 lg:p-3 shadow-lg mb-3">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-4">
                <div className="flex items-center gap-2 lg:gap-3 flex-wrap">
                    <h1 className="text-xl lg:text-2xl font-bold text-white">Lote #{lote.numero_lote}</h1>
                    <span className="bg-yellow-400 text-gray-900 px-2 lg:px-3 py-1 rounded-lg font-bold text-xs lg:text-sm">
                        {lote.categoria}
                    </span>
                </div>

                <div className="flex items-center flex-wrap gap-2 lg:gap-4">
                    <div className="flex items-center gap-1 lg:gap-2 text-white/90 text-xs lg:text-sm">
                        <MapPin className="w-3 h-3 lg:w-4 lg:h-4" />
                        <span className="font-semibold">{lote.departamento}</span>
                    </div>
                    <div className="hidden sm:flex items-center gap-1 lg:gap-2 text-white/90 text-xs lg:text-sm">
                        <Calendar className="w-4 h-4" />
                        <span className="font-semibold">{lote.inspeccion_fecha}</span>
                        {/* Preoferta / Precio Venta */}
                        <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3 text-center">
                            {lote.venta_estado === 'VE' ? (
                                <>
                                    <p className="text-white/80 text-xs font-medium uppercase tracking-wider mb-1">Vendido</p>
                                    <p className="text-white font-bold text-2xl">${lote.precio_venta}</p>
                                </>
                            ) : lote.venta_estado === 'NV' ? (
                                <>
                                    <p className="text-white/80 text-xs font-medium uppercase tracking-wider mb-1">Estado</p>
                                    <p className="text-red-200 font-bold text-2xl">No vendido</p>
                                </>
                            ) : lote.preoferta > 0 ? (
                                <>
                                    <p className="text-white/80 text-xs font-medium uppercase tracking-wider mb-1">Preoferta</p>
                                    <p className={`font-bold text-2xl ${lote.preoferta_estado === 'A' ? 'text-white' : 'text-yellow-300'}`}>
                                        ${lote.preoferta}
                                    </p>
                                </>
                            ) : (
                                <>
                                    <p className="text-white/80 text-xs font-medium uppercase tracking-wider mb-1">Estado</p>
                                    <p className="text-white/70 font-bold text-lg">Sin preofertas</p>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoteHeader;
